
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/use-cases",
      function () {
        return require("private-next-pages/use-cases.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/use-cases"])
      });
    }
  